import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing, breakpoints }: Theme) => createStyles({
  root: {
    width: 600,
    paddingTop: spacing(2),
    [breakpoints.up('lg')]: {
      width: 740,
    },
    [breakpoints.up('xl')]: {
      width: 936,
    },
  },
  description: {
    marginTop: spacing(3),
    color: colors.text.secondary,
  },
  button: {
    marginTop: spacing(6),
    marginBottom: spacing(3),
  },
  link: {
    '& svg': {
      transform: 'rotate(180deg)',
    },
  },
  systemError: {
    marginTop: spacing(4),
  },
  supportEmail: {
    marginTop: spacing(4),
  },
});

export default styles;
